// extracted by mini-css-extract-plugin
export default {"Loading":"bcs_a bia_a bia_w bia_j bia_ul bia_um bia_fm"};